/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Play_AgainInputs */

const bn_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আবার খেলুন`)
};

const de_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielen Sie noch einmal`)
};

const el_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ξαναπαίζω`)
};

const en_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play again`)
};

const es_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jugar de nuevo`)
};

const fr_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejouer`)
};

const hi_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिर से चालू करें`)
};

const hu_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játssz újra`)
};

const id_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mainkan lagi`)
};

const it_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioca di nuovo`)
};

const ja_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一度プレイしてください`)
};

const ko_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다시 플레이`)
};

const nl_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel opnieuw`)
};

const pl_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zagraj ponownie`)
};

const pt_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogue novamente`)
};

const ru_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играй еще раз`)
};

const sv_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spela igen`)
};

const tr_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar oyna`)
};

const uk_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грати знову`)
};

const vi_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi lại`)
};

const zh_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再玩一次`)
};

const zh_hant_action_play_again = /** @type {(inputs: Action_Play_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再玩一次`)
};

/**
* | output |
* | --- |
* | "Play again" |
*
* @param {Action_Play_AgainInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_play_again = /** @type {((inputs?: Action_Play_AgainInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Play_AgainInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_play_again(inputs)
	if (locale === "de") return de_action_play_again(inputs)
	if (locale === "el") return el_action_play_again(inputs)
	if (locale === "en") return en_action_play_again(inputs)
	if (locale === "es") return es_action_play_again(inputs)
	if (locale === "fr") return fr_action_play_again(inputs)
	if (locale === "hi") return hi_action_play_again(inputs)
	if (locale === "hu") return hu_action_play_again(inputs)
	if (locale === "id") return id_action_play_again(inputs)
	if (locale === "it") return it_action_play_again(inputs)
	if (locale === "ja") return ja_action_play_again(inputs)
	if (locale === "ko") return ko_action_play_again(inputs)
	if (locale === "nl") return nl_action_play_again(inputs)
	if (locale === "pl") return pl_action_play_again(inputs)
	if (locale === "pt") return pt_action_play_again(inputs)
	if (locale === "ru") return ru_action_play_again(inputs)
	if (locale === "sv") return sv_action_play_again(inputs)
	if (locale === "tr") return tr_action_play_again(inputs)
	if (locale === "uk") return uk_action_play_again(inputs)
	if (locale === "vi") return vi_action_play_again(inputs)
	if (locale === "zh") return zh_action_play_again(inputs)
	return zh_hant_action_play_again(inputs)
});